import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/api";
import { toast } from "react-toastify";




export const sendexcessEnquiryThunk = createAsyncThunk(
    'excess/sendexcessEnquiryThunk  ',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.sendExcessEnquiry(data);
            console.log(response.data);
            toast.success('Excess enquiry sent successfully')
            return response.status;

        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wronf')
        }
    }
);



export const uploadVendorExcessThunk = createAsyncThunk(
    'excess/uploadVendorExcess',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.uploadExcessEnquiry(data);
            console.log(response.data);
            toast.success('Excess inventory uploaded successfully')
            return response.status;

        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wronf')
        }
    }
);



export const getExcessStockDataThunk = createAsyncThunk(
    'excess/getExcessStockDataThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getExcessData(data);
            return response.data;

        } catch (error) {
            console.log(error);
        }
    }
);


export const deleteExcessStockThunk = createAsyncThunk(
    'excess/deleteExcessStockThunk',
    async (productNumber, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteExcessStock(productNumber);
            toast.success(response.data?.message || 'Item deleted successfully');
            return productNumber;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong');
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const getexcessEnquiriesSlice = createAsyncThunk(
    'excess/getexcessEnquiriesSlice',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getexcessEnquiry(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getexcessEnquirydetailsThunk = createAsyncThunk(
    'excess/getexcessEnquirydetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getexcessEnquirydetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getWizardEnquiriesSlice = createAsyncThunk(
    'excess/getWizardEnquiriesSlice',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getWizardEnquiry(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getWizardEnquirydetailsThunk = createAsyncThunk(
    'excess/getWizardEnquirydetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getWizardEnquirydetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const geAlluploadedExcessStockThunk = createAsyncThunk(
    'excess/geAlluploadedExcessStockThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getUploadedExcessdata(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const exporteduploadedExcessStockThunk = createAsyncThunk(
    'excess/exporteduploadedExcessStockThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getUploadedExcessdata(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getExcessStockdetailsThunk = createAsyncThunk(
    'bom/getExcessStockdetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getExcessStockdetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteProductFromVendorExcessThunk = createAsyncThunk(
    'excess/deleteProductFromVendorExcessThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFromvendorExcess(data);
            toast.success(response.data?.message || 'Item deleted successfully');
            dispatch(setvendorExcessrefresh());
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong');
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const getExcessStockcountThunk = createAsyncThunk(
    'excess/getExcessStockcountThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getExcessStockcount(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const excessSlice = createSlice({
    name: 'excess',
    initialState: {
        excesspreview: [],
        macthedProducts: [],
        alterProducts: {},
        loading: false,
        refresh: false,
        alterLoading: false,
        excessEnquiries: [],
        page: 1,
        excessenquirydetails: {},
        inputValue: '',
        quantities: {},
        selectedProducts: [],
        filename: null,
        excessStock: {
            data: [],
            page: 1
        },
        excessStockCount: {
            data: {},
            loading: false
        },
        uploadedExcessData: {
            data: [],
            page: 1
        },
        stockDetails: {},
        filter: [],
        appliedFilters: [],
        search: ""
    },
    reducers: {

        setexcessFileName: (state, action) => {
            state.filename = action.payload
        },
        setExcessStockPage: (state, action) => {
            state.excessStock.page = action.payload
        },
        setuploadedExcessStockPage: (state, action) => {
            state.uploadedExcessData.page = action.payload
        },
        setexcessPreview: (state, action) => {
            state.excesspreview = action.payload
        },
        deletexcessPreviewData: (state, action) => {
            state.excesspreview = []
            state.filename = null
        },
        setFileName: (state, action) => {
            state.filename = action.payload
        },
        setInputValue: (state, action) => {
            state.inputValue = action.payload
        },
        deleteInputValue: (state, action) => {
            state.inputValue = ''
        },
        setQuantities: (state, action) => {
            state.quantities = { ...state.quantities, ...action.payload };
        },
        setSelectedProducts: (state, action) => {
            state.selectedProducts = action.payload;
        },
        setexcessPage: (state, action) => {
            state.page = action.payload
        },
        setexcessEnquiry: (state, action) => {
            state.excessEnquiries = []
        },
        setExcessAppliedFilters: (state, action) => {
            state.appliedFilters = action.payload
        },
        setExcessSearch :(state,action)=>{
             state.search = action.payload
        },

        // ✅ Toggle product selection (add/remove)
        toggleProductSelection: (state, action) => {
            const { productId, isChecked } = action.payload;

            if (isChecked) {
                state.quantities[productId] = state.quantities[productId] || 1; // Default to 1 if not set
            } else {
                delete state.quantities[productId]; // Remove from selection
            }
        },

        deleteAlterProduct: (state, action) => {
            const partNumberToRemove = action.payload;

            state.alterProducts.alternateProducts = state.alterProducts.alternateProducts?.filter(
                (i) => {
                    const productNumber = Array.isArray(i?.productOverview?.productNumber)
                        ? i.productOverview.productNumber.join("")
                        : i?.productOverview?.productNumber;

                    return productNumber !== partNumberToRemove;
                }
            );
        },
        updateProductQuantity: (state, action) => {
            const { id, quantity } = action.payload; // Change _id to id
            if (state.excessStock.data[id]) {
                // alert(id)
                state.excessStock.data[id].quantity = quantity; // Correct way to update state
            }
        },
        setExcessFilter: (state, action) => {
            state.filter = action.payload
        },
        setvendorExcessrefresh: (state) => {
            state.refresh = !state.refresh;
        }

    },
    extraReducers: (builder) => {
        builder



            .addCase(getexcessEnquiriesSlice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getexcessEnquiriesSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.excessEnquiries = action.payload
            })
            .addCase(getexcessEnquiriesSlice.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getexcessEnquirydetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getexcessEnquirydetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excessenquirydetails = action.payload
            })
            .addCase(getexcessEnquirydetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getWizardEnquiriesSlice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getWizardEnquiriesSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.excessEnquiries = action.payload
            })
            .addCase(getWizardEnquiriesSlice.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getWizardEnquirydetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getWizardEnquirydetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excessenquirydetails = action.payload
            })
            .addCase(getWizardEnquirydetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })



            .addCase(getExcessStockDataThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getExcessStockDataThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excessStock.data = action.payload
            })
            .addCase(getExcessStockDataThunk.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteExcessStockThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteExcessStockThunk.fulfilled, (state, action) => {
                state.loading = false;
                const productNumber = action.payload;
                if (state.excessStock.data && Array.isArray(state.excessStock.data.data)) {
                    state.excessStock.data.data = state.excessStock.data.data.filter(
                        (item) => item.productNumber !== productNumber
                    );
                }
            })
            .addCase(deleteExcessStockThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(geAlluploadedExcessStockThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(geAlluploadedExcessStockThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.uploadedExcessData.data = action.payload
            })
            .addCase(geAlluploadedExcessStockThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getExcessStockdetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getExcessStockdetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.stockDetails = action.payload
            })
            .addCase(getExcessStockdetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getExcessStockcountThunk.pending, (state) => {
                state.excessStockCount.loading = true;
            })
            .addCase(getExcessStockcountThunk.fulfilled, (state, action) => {
                state.excessStockCount.loading = false;
                state.excessStockCount.data = action.payload
            })
            .addCase(getExcessStockcountThunk.rejected, (state, action) => {
                state.excessStockCount.loading = false;
            })

    },
})

export const { setexcessPreview, setexcessFileName, deleteAlterProduct, updateProductQuantity, deletexcessPreviewData, setFileName, setInputValue, deleteInputValue, setQuantities, toggleProductSelection, setSelectedProducts, setexcessPage, setexcessEnquiry, setExcessStockPage, setuploadedExcessStockPage, setExcessFilter,setExcessAppliedFilters,setExcessSearch, setvendorExcessrefresh } = excessSlice.actions;
export default excessSlice.reducer
